module.exports = __webpack_public_path__ + "img/dataImg.64aac3b1.png";